export enum DebounceDelay {
  Short = 200,
  Long = 300
}
